// Next Diamonds — Cookie consent banner
// Slide-up banner on first visit. Stores choice in localStorage and
// (when available) propagates to Shopify's customerPrivacy API so
// Shopify-native analytics + marketing pixels respect the choice.

(function () {
  'use strict';

  var STORAGE_KEY = 'nd-cookie-consent';
  var VERSION = '1';  // bump to force re-prompt if categories change

  function readConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (parsed && parsed.v === VERSION) return parsed;
      return null;
    } catch (e) { return null; }
  }

  function saveConsent(consent) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        v: VERSION,
        timestamp: Date.now(),
        essential: true,
        analytics: !!consent.analytics,
        marketing: !!consent.marketing
      }));
    } catch (e) {}
    // Tell Shopify's privacy API if it's loaded
    try {
      if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
        Shopify.customerPrivacy.setTrackingConsent(!!consent.analytics || !!consent.marketing, function () {});
      }
    } catch (e) {}
    // Notify listeners
    document.dispatchEvent(new CustomEvent('nd:cookie-consent', { detail: consent }));
  }

  function buildBanner() {
    var banner = document.createElement('div');
    banner.className = 'nd-cookie-banner';
    banner.setAttribute('role', 'dialog');
    banner.setAttribute('aria-label', 'Cookie consent');
    banner.innerHTML =
      '<div class="nd-cookie-banner__card">' +
        '<div class="nd-cookie-banner__head">' +
          '<h2 class="nd-cookie-banner__title">Cookies</h2>' +
        '</div>' +
        '<p class="nd-cookie-banner__copy">' +
          'We use cookies to make the site work, understand how it\'s used, and personalize content. ' +
          'You can accept all, reject non-essential, or manage your preferences. ' +
          '<a href="/policies/privacy-policy">Privacy policy</a>.' +
        '</p>' +
        '<div class="nd-cookie-banner__actions">' +
          '<button type="button" class="nd-cookie-banner__btn nd-cookie-banner__btn--primary" data-nd-cookie-accept-all>Accept all</button>' +
          '<button type="button" class="nd-cookie-banner__btn" data-nd-cookie-reject>Reject non-essential</button>' +
          '<button type="button" class="nd-cookie-banner__btn nd-cookie-banner__btn--ghost" data-nd-cookie-manage>Manage preferences</button>' +
        '</div>' +
        '<div class="nd-cookie-banner__panel" data-nd-cookie-panel>' +
          '<div class="nd-cookie-cat">' +
            '<div>' +
              '<p class="nd-cookie-cat__title">Essential</p>' +
              '<p class="nd-cookie-cat__desc">Required for the site to function (cart, checkout, security). Cannot be disabled.</p>' +
            '</div>' +
            '<label class="nd-cookie-switch">' +
              '<input type="checkbox" checked disabled>' +
              '<span class="nd-cookie-switch__slider"></span>' +
            '</label>' +
          '</div>' +
          '<div class="nd-cookie-cat">' +
            '<div>' +
              '<p class="nd-cookie-cat__title">Analytics</p>' +
              '<p class="nd-cookie-cat__desc">Helps us understand how visitors use the site so we can improve it.</p>' +
            '</div>' +
            '<label class="nd-cookie-switch">' +
              '<input type="checkbox" data-nd-cookie-cat="analytics">' +
              '<span class="nd-cookie-switch__slider"></span>' +
            '</label>' +
          '</div>' +
          '<div class="nd-cookie-cat">' +
            '<div>' +
              '<p class="nd-cookie-cat__title">Marketing</p>' +
              '<p class="nd-cookie-cat__desc">Used to show relevant ads and measure their performance.</p>' +
            '</div>' +
            '<label class="nd-cookie-switch">' +
              '<input type="checkbox" data-nd-cookie-cat="marketing">' +
              '<span class="nd-cookie-switch__slider"></span>' +
            '</label>' +
          '</div>' +
          '<div class="nd-cookie-banner__panel-actions">' +
            '<button type="button" class="nd-cookie-banner__btn nd-cookie-banner__btn--primary" data-nd-cookie-save>Save preferences</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    return banner;
  }

  function buildReopener() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nd-cookie-reopen';
    btn.setAttribute('aria-label', 'Cookie preferences');
    btn.textContent = 'Cookies';
    btn.addEventListener('click', function () { showBanner(/* fromReopen */ true); });
    return btn;
  }

  var bannerEl, reopenEl;

  function showBanner(fromReopen) {
    if (!bannerEl) bannerEl = document.body.appendChild(buildBanner());
    wireBannerEvents();
    if (fromReopen) preloadFromStorage();
    requestAnimationFrame(function () {
      bannerEl.classList.add('is-visible');
    });
    if (reopenEl) reopenEl.classList.remove('is-visible');
  }

  function hideBanner() {
    if (!bannerEl) return;
    bannerEl.classList.remove('is-visible');
    bannerEl.classList.remove('is-expanded');
    if (reopenEl) reopenEl.classList.add('is-visible');
  }

  function preloadFromStorage() {
    var consent = readConsent();
    if (!consent) return;
    var an = bannerEl.querySelector('[data-nd-cookie-cat="analytics"]');
    var mk = bannerEl.querySelector('[data-nd-cookie-cat="marketing"]');
    if (an) an.checked = !!consent.analytics;
    if (mk) mk.checked = !!consent.marketing;
  }

  function wireBannerEvents() {
    if (bannerEl.__ndWired) return;
    bannerEl.__ndWired = true;
    bannerEl.querySelector('[data-nd-cookie-accept-all]').addEventListener('click', function () {
      saveConsent({ analytics: true, marketing: true });
      hideBanner();
    });
    bannerEl.querySelector('[data-nd-cookie-reject]').addEventListener('click', function () {
      saveConsent({ analytics: false, marketing: false });
      hideBanner();
    });
    bannerEl.querySelector('[data-nd-cookie-manage]').addEventListener('click', function () {
      bannerEl.classList.toggle('is-expanded');
      preloadFromStorage();
    });
    bannerEl.querySelector('[data-nd-cookie-save]').addEventListener('click', function () {
      var an = bannerEl.querySelector('[data-nd-cookie-cat="analytics"]');
      var mk = bannerEl.querySelector('[data-nd-cookie-cat="marketing"]');
      saveConsent({ analytics: !!(an && an.checked), marketing: !!(mk && mk.checked) });
      hideBanner();
    });
  }

  function init() {
    // Always inject the small "Cookie settings" reopener so users can
    // change their mind later. Visible only after consent is set.
    reopenEl = document.body.appendChild(buildReopener());

    var consent = readConsent();
    if (consent) {
      // Already chose — keep the reopener visible, no banner
      reopenEl.classList.add('is-visible');
    } else {
      // First visit (or storage cleared) — show the banner after a tick
      // so it animates in cleanly.
      setTimeout(showBanner, 280);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
